import { call, put, takeEvery } from 'redux-saga/effects';
import { studentActions } from './studentSlice';

import { toastAction } from '../toast/toast';
import { getAll, getAssessmentResultPreview, getAssessmentSummaryByCourseAndId, getAssignmentProgressByCourseAndId, getGradeByTeacher, getProgressSummaryByCourseAndId, getStudentActivity } from './studentBaseApi';
import { getById } from './studentBaseApi';

export function* onChangeStudent(payload) {
    try {
        const { data } = yield call(getAll, payload);
        yield put(studentActions.setStudents(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}


export function* onChangeGrade(payload) {
    try {
        const { data } = yield call(getGradeByTeacher, payload);

        yield put(studentActions.setTeacherGrades(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeCurrentStudent({ payload }) {
    try {
        const { data } = yield call(getById, payload);
        yield put(studentActions.setCurrentStudent(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onChangeActivityStudent({ payload }) {
    try {
        const { data } = yield call(getStudentActivity, payload);
        yield put(studentActions.setActivityStudent(data.activities || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onChangeAssmentSummary({ payload }) {
    try {
        const { data } = yield call(getAssessmentSummaryByCourseAndId, payload);
        yield put(studentActions.setAssessmentSummary(data.assessmentSummary || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onChangeProgressSummary({ payload }) {
    try {
        const { data } = yield call(getProgressSummaryByCourseAndId, payload);
        yield put(studentActions.setProgressSummary(data.progressSummary || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onChangeAssignmentProgress({ payload }) {
    try {
        const { data } = yield call(getAssignmentProgressByCourseAndId, payload);
        yield put(studentActions.setAssignmentProgress(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}


export function* onChangeAssessmentResultPreview({ payload }) {
    try {
        const { data } = yield call(getAssessmentResultPreview, payload);
        yield put(studentActions.setAssessmentResult(data.assessments || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

function* studentWatcherSaga() {
    yield takeEvery(studentActions.loadStudents.type, onChangeStudent);
    yield takeEvery(studentActions.loadCurrentStudent.type, onChangeCurrentStudent);
    yield takeEvery(studentActions.loadActivities.type, onChangeActivityStudent);
    yield takeEvery(studentActions.loadAssessmentSummary.type, onChangeAssmentSummary);
    yield takeEvery(studentActions.loadProgressSummary.type, onChangeProgressSummary);
    yield takeEvery(studentActions.loadAssignmentProgress.type, onChangeAssignmentProgress);
    yield takeEvery(studentActions.loadTeacherGrade.type, onChangeGrade);
    yield takeEvery(studentActions.loadAssessmentResult.type, onChangeAssessmentResultPreview);
}


export default studentWatcherSaga;
